import React from 'react';
import { Navigate } from 'react-router-dom';
import { EnhancedRouteProps } from '../../../../routes/Enhanced/Enhanced.route';
import RfiList from './pages/RfiList';
import RfiCreate from './pages/RfiCreate';
import RfiCreateTemplate from './pages/RfiCreateTemplate';
import RfiDetails from './pages/RfiDetails';

export default [
  {
    path: 'list',
    element: RfiList,
  },
  {
    path: 'list/:id',
    element: RfiDetails,
  },
  {
    path: 'create',
    element: RfiCreate,
  },
  {
    path: 'create-template',
    element: RfiCreateTemplate,
  },
  {
    path: 'edit-template/:templateId',
    element: RfiCreateTemplate,
  },
  {
    index: true,
    element: <Navigate to="list" replace />,
  },
] as Array<EnhancedRouteProps>;
